import { Box, Grid } from "@mui/material";
import { ReactComponent as TimeClockCircle } from "assets/TimeClockCircle.svg";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";

export default function Timing(props: any) {
  const {
    duration: [hours, minutes],
    variant = "body2",
    label = "",
    color
  } = props;

  return (
    <Grid display="flex" alignItems={"center"}>
      <Box marginRight={"6px"} display="flex" alignItems={"center"}>
        <TimeClockCircle />
      </Box>
      {label && (
        <Typography variant="body2" color={tokens.Text.General.Secondary}>
          {label}:
        </Typography>
      )}
      <Typography variant={variant} color={color}>
        {hours > 0 && `${hours}h`}
        {hours > 0 && minutes > 0 && ` ${minutes}m`}
        {hours === 0 && `${minutes}m`}
      </Typography>
    </Grid>
  );
}
